import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

const REQUEST_TIMEOUT = 60000;
export const ACCESS_TOKEN = "MEGACOIN-APP-ACCESS-TOKEN";
export class Client {
  client: any;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async request<T>(
    config: AxiosRequestConfig,
    authHeaders?: any
  ): Promise<AxiosResponse<T>> {
    return this.client.request({
      ...config,
      headers: {
        ...(config.headers || {}),
        ...(authHeaders || {}),
      },
    });
  }
}

const httpClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  timeout: REQUEST_TIMEOUT,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
});

/* eslint-disable no-console */
/* istanbul ignore next debug log */
const isDebug = !process.env.NODE_ENV || process.env.NODE_ENV === "development";
if (isDebug) {
  httpClient.interceptors.request.use(
    (config) => {
      console.log("\n\n\n ---- BEGIN Request config ---- \n\n\n");
      console.log("Base Url", config.baseURL);
      console.log("Method", config.method);
      console.log("Url", config.url);
      console.log("Params", JSON.stringify(config.params));
      console.log("Data", JSON.stringify(config.data));
      console.log("Headers", JSON.stringify(config.headers));

      console.log("\n\n\n ---- END Request config ---- \n\n\n");
      return config;
    },
    (error) => {
      console.log(JSON.stringify(error));
      return Promise.reject(error);
    }
  );

  httpClient.interceptors.response.use(
    (response) => {
      console.log("\n\n\n ---- BEGIN Response ---- \n\n\n");

      console.log("Config", JSON.stringify(response.config.url));
      console.log("Status", JSON.stringify(response.status));
      console.log("Data", JSON.stringify(response.data));

      console.log("\n\n\n ---- END Response ---- \n\n\n");
      return response;
    },
    (error) => {
      console.log("\n\n\n ---- BEGIN Error ---- \n\n\n");

      console.log("Error", JSON.stringify(error));
      if (error.response) {
        console.log("Error Response", JSON.stringify(error.response));
      }

      console.log("\n\n\n ---- END Error ---- \n\n\n");
      return Promise.reject(error);
    }
  );
}

export default new Client(httpClient);
